import { SyntheticEvent } from 'react';

import { BaseEditor, Editor, Element, Transforms } from 'slate';
import { ReactEditor, useSlate } from 'slate-react';

import { LIST_TYPES, TEXT_ALIGN_TYPES } from '../../consts';
import Icon from '../Icon';
import Button from './index';

const isBlockActive = (editor: BaseEditor & ReactEditor, format: string, blockType = 'type') => {
  const { selection } = editor;
  if (!selection) return false;

  const [match] = Array.from(
    Editor.nodes(editor, {
      at: Editor.unhangRange(editor, selection),
      match: (n: any) => n[blockType] === format && Element.isElement(n) && !Editor.isEditor(n),
    }),
  );

  return !!match;
};

const toggleBlock = (editor: BaseEditor & ReactEditor, format: string) => {
  const isActive = isBlockActive(editor, format, TEXT_ALIGN_TYPES.includes(format) ? 'align' : 'type');
  const isList = LIST_TYPES.includes(format);

  Transforms.unwrapNodes(editor, {
    match: (n: any) => !TEXT_ALIGN_TYPES.includes(format) && LIST_TYPES.includes(n.type) && Element.isElement(n) && !Editor.isEditor(n),
    split: true,
  });
  let newProperties: any;
  if (TEXT_ALIGN_TYPES.includes(format)) {
    newProperties = {
      align: isActive ? undefined : format,
    };
  } else {
    newProperties = {
      type: isActive ? 'paragraph' : isList ? 'list-item' : format,
    };
  }
  Transforms.setNodes<Element>(editor, newProperties);

  if (!isActive && isList) {
    const block = { type: format, children: [] };
    Transforms.wrapNodes(editor, block);
  }
};

function BlockButton({ format, icon }: any) {
  const editor = useSlate();
  return (
    <Button
      active={isBlockActive(editor, format, TEXT_ALIGN_TYPES.includes(format) ? 'align' : 'type')}
      onMouseDown={(event: SyntheticEvent) => {
        event.preventDefault();
        toggleBlock(editor, format);
      }}
    >
      <Icon>{icon}</Icon>
    </Button>
  );
}

export default BlockButton;
